module.exports = __webpack_public_path__ + "static/media/codeReview.f7463b9e.jpg";